<template>
  <div class="race">
    <div class="race__inner">
      <vue-audio :file="6" ref="raceTextStart"></vue-audio>
      <div class="race__info">
        <div class="race__info__inner">
          <div class="race__info__row">
            <div class="title">サイコロを振って競争しよう！</div>
            <!--<div class="race__info__right">-->
            <!--<a href="" class="game-top" @click="gameTop">GAME TOP</a>-->
            <!--<div class="sound">SOUND</div>-->
            <!--</div>-->
          </div>
          <div class="race__info__row">
            <div class="main-score">
              <span class="text">あなたのユニコーン</span>
              <span class="score">{{ finalDistanceA }}M</span>
            </div>
            <div class="com-score">
              <span class="text">競争相手のユニコーン</span>
              <span class="score">{{ finalDistanceB }}M</span>
            </div>
          </div>
        </div>
      </div>
      <div class="race__meter">
        <span class="meter">2000M</span>
      </div>
      <div class="race__street">
        <div class="street__background">
          <p class="start"></p>
          <p class="goal"></p>
        </div>
        <div class="race__content">
          <horse id="user"></horse>
          <horse id="pc"></horse>
          <!--<p class="race_competition">サイコロを振って競争スタート</p>-->
        </div>
      </div>
      <div class="race__dice">
        <match-dice :isGoal="isGoal"></match-dice>
      </div>
      <div class="race__text">
        <div class="race__text__start" v-show="showRaceTextStart"><img src="../assets/image/text_start.png" alt=""></div>
        <div class="race__text__goal" v-show="showRaceTextGoal"><img src="../assets/image/text_goal.png" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
  import Horse from './Horse'
  import MatchDice from './MatchDice'
  import { store } from '../store/store'
  import Audio from './Audio'
  import _ from 'lodash'
  export default {
    name: 'RaceScreen',
    data () {
      return {
        isGoal: false,
        timeLine: -1,
        TM: -1
      }
    },
    computed: {
      finalDistanceA () {
        if (store.state.finalDistanceA === 0) {
          return '0000'
        } else if (store.state.finalDistanceA < 100) {
          return '00' + _.round(store.state.finalDistanceA)
        } else if (store.state.finalDistanceA >= 100 && store.state.finalDistanceA < 1000) {
          return '0' + _.round(store.state.finalDistanceA)
        } else if (store.state.finalDistanceA > 2000) {
          return '2000'
        } else return _.round(store.state.finalDistanceA)
      },
      finalDistanceB () {
        if (store.state.finalDistanceB === 0) {
          return '0000'
        } else if (store.state.finalDistanceB < 100) {
          return '00' + _.round(store.state.finalDistanceB)
        } else if (store.state.finalDistanceB >= 100 && store.state.finalDistanceB < 1000) {
          return '0' + _.round(store.state.finalDistanceB)
        } else if (store.state.finalDistanceB > 2000) {
          return '2000'
        } else return _.round(store.state.finalDistanceB)
      },
      showRaceTextStart () {
        return store.state.showRaceTextStart
      },
      showRaceTextGoal () {
        this.isGoal = store.state.showRaceTextGoal
//        store.dispatch('setResult', false)
//        if (this.finalDistanceA > this.finalDistanceB) {
//          store.dispatch('setResult', true)
//        }
        setTimeout(this.toResult, 3000)
        return this.isGoal
      },
      resetStatus () {
        return store.state.resetStatus
      },
      currentScreen () {
        return store.state.currentScreen
      }
    },
    created () {
//      store.dispatch('setHorseStatus')
      store.dispatch('showRaceTextStart', true)
      store.dispatch('showRaceTextGoal', false)
      store.dispatch('setPcDiceStatus', false)
      store.getters.getResetDistance()
    },
    mounted () {
      this.timeLine = new TimelineMax({pause: true})
      TweenMax.set('.race__text__start', {opacity: '0', y: 40})
      this.TM1 = TweenMax.to('.race__text__start', 0.7, {repeat: -1, opacity: 1, ease: Power2.easeNone, yoyo: true})
      this.timeLine.append(this.TM1)
      this.timeLine.addPause(2, this.onCompleteTextStart)
      this.timeLine.play()
      TweenMax.set('.race__text__goal', {x: '10px', scale: 0.8})
      TweenMax.to('.race__text__goal', 0.7, {ease: Circ.easeNone, scale: 1, repeat: -1, yoyo: true})
      // Play audio
      this.$refs.raceTextStart.play()
    },
    components: {
      'horse': Horse,
      'match-dice': MatchDice,
      'vue-audio': Audio
    },
    methods: {
      gameTop () {
        store.dispatch('setCurrentScreen', 'welcome')
      },
      getHouseStatus () {
        store.dispatch('setHorseStatus')
      },
      toResult () {
        if (this.isGoal && this.currentScreen === 'race') {
          store.dispatch('setCurrentScreen', 'result')
        }
      },
      onCompleteTextStart () {
        this.timeLine.pause(0)
        store.dispatch('showRaceTextStart', false)
      }
    },
    watch: {
      resetStatus (val) {
        console.log(val)
        if (val) {
          this.timeLine.kill()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RaceScreen.vue?172df659